import { render } from "./index.vue?vue&type=template&id=5368da49&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./css/index.scss?vue&type=style&index=0&id=5368da49&lang=scss&scoped=true"

import exportComponent from "C:\\a_my\\ts\\new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5368da49"]])

export default __exports__